import { Col, Row, Container } from "react-bootstrap"
import styled from "styled-components"
import { useTranslation } from "~/i18n"
import Text from "../UI/Text"
import Branches from "./Branches"
import Contact from "./Contact"
import Info from "./Info"
import Links from "./Links"

const MyContainer = styled.div`
  background-color: rgba(235, 243, 255, 0.4);
  padding: 50px 0;
`
const Footer = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <Row>
          <Col lg={4}>
            <Info />
          </Col>
          <Col lg={3}>
            <Branches />
          </Col>
          <Col lg={2}>
            <Links />
          </Col>
          <Col style={{ paddingRight: 0 }} lg={3}>
            <Contact />
          </Col>
        </Row>
      </Container>
      <Text centered margin='50px 0 20px 0'>
        {t`Copyright`} © {new Date().getFullYear()} | {t`Infina. All rights reserved`}.
      </Text>
    </MyContainer>
  )
}

export default Footer